import React from 'react'
import Table from '../../../../common/components/table'

 
export default function TenantWebsiteCardComponent ({onDelete,additionButtons,rowData,columnDefs,onEdit,paginationData,setPageData}: any) {
  return (
    <>

<Table columnData={columnDefs} rowData={rowData} 
     onEdit={onEdit} onDelete={onDelete} additionButtons={additionButtons} headingName="Tenant Website Cards"/>
                   
   
        </>
  )
}